import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import { Layout } from 'antd';
import { Anual } from './ConsultasImpuestos/Anual';
import { Aperturas } from './Aperturas';
import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import { Aprobaciones } from './Aprobaciones';
import { Captura } from './Captura';
import { ConsultasImpuestos } from './ConsultasImpuestos';
import {Anexos} from './ConsultasImpuestos/Anexos';
import {ConsultaMensual} from './ConsultasImpuestos/ConsultaMensual';
import { DefaultPage } from './DefaultPage';
import Login from './Login';
import { Notificaciones } from './Notificaciones';
import PrivateRoute from './PrivateRoute';
import { Usuarios } from './Usuarios';



const AppLayout = styled(Layout)`
    min-height: 100% !important;
`;

const AppContent = Layout.Content;

class App extends React.Component<RouteComponentProps> {
    render() {
        return (
            <AppLayout>
                <AppHeader />
                <AppContent>
                    <Switch>
                        <Route exact={true} path="/" component={DefaultPage} />
                        <PrivateRoute path="/login" component={Login} />
                        <PrivateRoute path="/captura" component={Captura} />
                        <PrivateRoute path="/revisión/captura" component={Captura} />
                        <PrivateRoute path="/revisión/aprobaciones" component={Aprobaciones} />
                        <PrivateRoute
                            path="/configuración/notificaciones"
                            component={Notificaciones}
                        />
                        <PrivateRoute path="/consulta/capturas" component={ConsultasImpuestos} />
                        <PrivateRoute path='/consulta/mensual' component={ConsultaMensual}/>
                        <PrivateRoute path='/consulta/anexos' component={Anexos}/>
                        <PrivateRoute path='/consulta/anual' component={Anual}/>
                        <PrivateRoute path='/configuración/usuarios' component={Usuarios}/>
                        <PrivateRoute path='/configuración/aperturas' component={Aperturas}/>
                    </Switch>
                </AppContent>
                <AppFooter />
            </AppLayout>
        );
    }
}

export default withRouter(App);
